module.exports = __webpack_public_path__ + "89889688147bd7575d6327160d64e760.svg";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/glyphicons-halflings-regular.svg
// module id = 307
// module chunks = 0